<template>
  <div>
    <van-tabbar v-model="active" v-show="!isKeyboardOpen"> <!-- 键盘弹出时隐藏 -->
      <van-tabbar-item to="/connection">
        <div class="van-tabbar-item__text">
          <van-icon name="wap-home-o" />
          <div>
            联系我们
          </div>
        </div>
      </van-tabbar-item>
      <van-tabbar-item to="/message">
        <div class="van-tabbar-item__text">
          <div>
            <van-icon name="chat-o" />
          </div>
          <div>信息通知</div>
        </div>
      </van-tabbar-item>
      <van-tabbar-item to="/product">
        <div class="van-tabbar-item__text">
          <div>
            <van-icon name="apps-o" />
          </div>
          <div>产品中心</div>
        </div>
      </van-tabbar-item>
      <van-tabbar-item to="/applyFor">
        <div class="van-tabbar-item__text">
          <div>
            <van-icon name="orders-o" />
          </div>
          <div>试用申请</div>
        </div>
      </van-tabbar-item>
      <van-tabbar-item to="/userInfo">
        <div class="van-tabbar-item__text">
          <div>
            <van-icon name="user-o" />
          </div>
          <div>个人中心</div>
        </div>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>


<script>
export default {
  data() {
    return {
      active: 2,
      hash:'',
      isKeyboardOpen: false, // 用于跟踪键盘是否打开
    };
  },
  mounted() {
    var hashPart = window.location.hash
    var hashPath = hashPart.split('?')[0]
    this.hash = hashPath.substring(1)
    this.active = this.hash === '/connection' ? 0 : this.hash === '/message' ? 1 : this.hash === '/product' ? 2 : this.hash === '/applyFor' ? 3 : this.hash === '/userInfo' ? 4 : 2;
    console.log(this.active,window.location);
    // 监听窗口大小的变化，判断键盘是否打开
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      // 判断窗口高度变化是否为键盘弹出/收起
      if (window.innerHeight < 500) { // 可以根据具体设备和需求调整高度
        this.isKeyboardOpen = true;
      } else {
        this.isKeyboardOpen = false;
      }
    }
  }
}

</script>

<style>
.van-tabbar-item__text {
  font-size: 0.14rem;
  vertical-align: middle;
}

.van-tabbar-item__text {
  text-align: center;
}
</style>